export default [
    {
        path: 'mapas',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'MapaController' }
    }, {
        path: 'mapa/show',
        component: require('./Show').default,
        meta: { middleware: 'auth', controller: 'MapaController' }
    },
];


